(() => {
  if (window.pxReferencePages) return;
  window.pxReferencePages = true;
  const enhance = () => {
    const main = document.querySelector('#MainContent');
    if (!main) return;
    const handle = document.body.dataset.pxPageHandle;
    if (handle === 'faqs') {
      const content = main.querySelector('.pujimax-page--faqs');
      if (!content || content.dataset.pxFaqReady) return;
      content.dataset.pxFaqReady = 'true';
      const groups = [];
      let current;
      [...content.children].forEach((node) => {
        if (node.matches('h2')) {
          current = { heading: node, nodes: [node], count: 0 };
          groups.push(current);
        } else if (current) {
          current.nodes.push(node);
          if (node.matches('details')) current.count++;
        }
      });
      const topics = groups.filter((group) => group.count);
      if (topics.length < 2) return;
      const controls = document.createElement('div');
      controls.className = 'px-reference-faq-filter';
      const label = document.createElement('label');
      const select = document.createElement('select');
      select.id = 'PXReferenceFaqTopic';
      label.htmlFor = select.id;
      label.textContent = 'Filter by topic';
      select.add(new Option('All', 'all'));
      topics.forEach((group, index) => select.add(new Option(group.heading.textContent.trim(), String(index))));
      controls.append(label, select);
      topics[0].heading.before(controls);
      select.addEventListener('change', () => {
        topics.forEach((group, index) => group.nodes.forEach((node) => {
          node.hidden = select.value !== 'all' && select.value !== String(index);
        }));
      });
      // A deep link must remain visible even when its topic was previously filtered out.
      const revealHash = () => {
        let id;
        try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
        const target = id && document.getElementById(id);
        if (!target || !content.contains(target)) return;
        select.value = 'all';
        topics.forEach((group) => group.nodes.forEach((node) => { node.hidden = false; }));
        const detail = target.closest('details');
        if (detail) detail.open = true;
      };
      window.addEventListener('hashchange', revealHash);
      revealHash();
    }
    if (handle === 'contact') {
      const content = main.querySelector('.pujimax-page--contact-us');
      const form = main.querySelector('.contact-form');
      const support = content?.querySelector('.pujimax-contact-card');
      if (!content || !form || !support || content.dataset.pxContactReady) return;
      content.dataset.pxContactReady = 'true';
      const originalSection = form.closest('.shopify-section');
      const layout = document.createElement('div');
      layout.className = 'px-reference-contact-layout';
      const aside = document.createElement('aside');
      aside.className = 'px-reference-contact-aside';
      aside.setAttribute('aria-label', support.querySelector('h3')?.textContent || 'Customer support');
      const introduction = content.querySelector('h2');
      if (!introduction) return;
      // Move existing nodes, never duplicate a form, change its action or intercept submission.
      const formColumn = document.createElement('div');
      formColumn.className = 'px-reference-contact-form-column';
      introduction.before(layout);
      let node = introduction;
      while (node && (node === introduction || !node.matches('h2'))) {
        const next = node.nextElementSibling;
        formColumn.append(node);
        node = next;
      }
      introduction.after(form);
      aside.append(support);
      layout.append(formColumn, aside);
      if (originalSection && !originalSection.textContent.trim() && !originalSection.querySelector('input,button,img,iframe')) {
        originalSection.hidden = true;
      }
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance, { once: true });
  else enhance();
  document.addEventListener('shopify:section:load', enhance);
})();
